export const responsiveSize = [
    375,
    390,
    540
]